import SegmentString from './SegmentString'
export default class NodableSegmentString {
  addIntersection(intPt, segmentIndex) {}
  get interfaces_() {
    return [SegmentString]
  }
}
